/* ERA - liste d'attente, parcours en deux temps (option C, 12/09/2026).

   Ecran 1 : e-mail seul. Des la validation, le profil part dans la liste
   Klaviyo du produit. Aucune inscription ne peut etre perdue ensuite.
   Ecran 2 : les 2 heures d'avance contre le numero. Le numero part sur
   /client/profiles/ et non sur /client/subscriptions/ : ce dernier ignore
   les attributs quand l'abonnement a la liste existe deja (voir posterProfil).
   Ecran 3 : confirmation.

   La finalite annoncee a la cliente est l'alerte de retour en stock. Le
   consentement SMS est recueilli separement, par une case decochee.

   Le numero est ecrit a DEUX endroits : l'attribut phone_number du profil, et
   la propriete « Numero liste attente ». Si Klaviyo refuse le format E.164
   sur l'attribut, la propriete reste lisible dans l'export de la liste. */
(function () {
  'use strict';

  var CFG = window.ERA_WAITLIST || {};
  var API_ABO = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var API_PROFIL = 'https://a.klaviyo.com/client/profiles/?company_id=';
  var REVISION = '2025-07-15';

  var racine, etape1, etape2, blocOk, okPrio;
  var formEmail, champEmail, boutonEmail, erreurEmail;
  var formTel, champTel, caseSms, boutonTel, erreurTel, refus;
  var ligneProduit, ligneProduit2;

  /* Indicatif telephonique par pays de marche Shopify. La boutique livre la
     France, la Suisse, la zone Europe et l'outre-mer : la liste suit les zones
     d'expedition. Repli France. */
  var INDICATIFS = {
    FR: '+33', CH: '+41', BE: '+32', LU: '+352', DE: '+49', ES: '+34',
    IT: '+39', NL: '+31', PT: '+351', RE: '+262', YT: '+262', GP: '+590',
    MF: '+590', BL: '+590', MQ: '+596', GF: '+594', PM: '+508', NC: '+687',
    PF: '+689', WF: '+681'
  };
  var INDICATIF = INDICATIFS[(CFG.pays || 'FR').toUpperCase()] || '+33';

  /* Indicatifs connus, les plus longs d'abord, pour reperer un zero national
     colle derriere l'indicatif. */
  var CODES = (function () {
    var vus = {}, liste = [];
    for (var k in INDICATIFS) {
      var c = INDICATIFS[k].replace(/\D/g, '');
      if (!vus[c]) { vus[c] = 1; liste.push(c); }
    }
    return liste.sort(function (a, b) { return b.length - a.length; });
  })();

  var handleCourant = null;
  var emailCourant = null;
  var dernierFocus = null;
  var fermetureAuto = null;

  function q(sel) { return racine ? racine.querySelector(sel) : null; }

  function init() {
    racine = document.querySelector('[data-era-wl]');
    if (!racine) return false;

    etape1 = q('[data-era-wl-etape1]');
    etape2 = q('[data-era-wl-etape2]');
    blocOk = q('[data-era-wl-ok]');
    okPrio = q('[data-era-wl-ok-prio]');

    formEmail = q('[data-era-wl-form-email]');
    champEmail = q('[data-era-wl-email]');
    boutonEmail = q('[data-era-wl-envoyer-email]');
    erreurEmail = q('[data-era-wl-erreur-email]');

    formTel = q('[data-era-wl-form-tel]');
    champTel = q('[data-era-wl-tel]');
    caseSms = q('[data-era-wl-sms]');
    boutonTel = q('[data-era-wl-envoyer-tel]');
    erreurTel = q('[data-era-wl-erreur-tel]');
    refus = q('[data-era-wl-refus]');

    ligneProduit = q('[data-era-wl-produit]');
    ligneProduit2 = q('[data-era-wl-produit2]');

    racine.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-era-wl-close')) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !racine.hidden) fermer();
    });

    if (formEmail) formEmail.addEventListener('submit', envoyerEmail);
    if (formTel) formTel.addEventListener('submit', envoyerTel);
    if (refus) refus.addEventListener('click', function () { afficherOk(false); });

    return true;
  }

  function titreProduit() {
    return (CFG.titres && CFG.titres[handleCourant]) || handleCourant || '';
  }

  /* Mise au format E.164.
     Le champ est vide : la quasi-totalite des visiteuses tapent leur numero
     au format national (06..., 07...). On leur applique l'indicatif de leur
     marche Shopify. Celles qui tapent leur numero en international (+ ou 00)
     sont respectees telles quelles.
     Limite assumee : une visiteuse etrangere sur le marche France qui tape son
     numero au format national sera prefixee en +33. Le format national est
     identique dans plusieurs pays, c'est indetectable, et la part concernee
     est marginale. La saisie exacte reste conservee dans « Numero saisi brut ». */
  function normaliserTelephone(brut) {
    var t = (brut || '').replace(/[^\d+]/g, '');
    if (!t) return null;

    if (t.slice(0, 2) === '00') t = '+' + t.slice(2);
    if (t.charAt(0) === '+') {
      var international = t.slice(1).replace(/\D/g, '');
      /* Cas tres frequent : le champ est pre-rempli « +33 » et la visiteuse
         tape son numero complet derriere, zero compris (+33 06...). Aucun
         numero national ne commence par zero une fois l'indicatif pose : on
         retire ce zero en trop. */
      for (var i = 0; i < CODES.length; i++) {
        var c = CODES[i];
        if (international.slice(0, c.length) === c && international.charAt(c.length) === '0') {
          international = c + international.slice(c.length + 1);
          break;
        }
      }
      return international.length >= 8 && international.length <= 15 ? '+' + international : null;
    }

    var n = t.replace(/\D/g, '');
    var ind = INDICATIF.replace(/\D/g, '');

    if (n.charAt(0) === '0') {
      n = n.replace(/^0+/, '');
    } else if (n.slice(0, ind.length) === ind) {
      /* indicatif saisi sans le + */
      return n.length >= 8 && n.length <= 15 ? '+' + n : null;
    }

    if (n.length < 6 || n.length > 12) return null;
    var complet = ind + n;
    return complet.length >= 8 && complet.length <= 15 ? '+' + complet : null;
  }

  function montrer(el, visible) { if (el) el.hidden = !visible; }

  function cacherErreur(el) { if (el) { el.hidden = true; el.textContent = ''; } }

  function afficherErreur(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function ouvrir(handle) {
    if (!racine && !init()) return;
    if (fermetureAuto) { clearTimeout(fermetureAuto); fermetureAuto = null; }

    handleCourant = handle || null;
    emailCourant = null;

    if (ligneProduit) ligneProduit.textContent = titreProduit();
    if (ligneProduit2) ligneProduit2.textContent = titreProduit();

    cacherErreur(erreurEmail);
    cacherErreur(erreurTel);
    if (champEmail) champEmail.value = '';
    if (champTel) champTel.value = '';
    if (caseSms) caseSms.checked = false;
    if (boutonEmail) { boutonEmail.disabled = false; boutonEmail.textContent = 'PRÉVIENS-MOI'; }
    if (boutonTel) { boutonTel.disabled = false; boutonTel.textContent = "OUI, JE VEUX MES 2 H D'AVANCE"; }

    montrer(etape1, true);
    montrer(etape2, false);
    montrer(blocOk, false);
    montrer(okPrio, false);

    dernierFocus = document.activeElement;
    racine.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (champEmail) setTimeout(function () { champEmail.focus(); }, 30);
  }

  function fermer() {
    if (!racine) return;
    if (fermetureAuto) { clearTimeout(fermetureAuto); fermetureAuto = null; }
    racine.hidden = true;
    document.documentElement.style.overflow = '';
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function afficherEtape2() {
    montrer(etape1, false);
    montrer(etape2, true);
    montrer(blocOk, false);
    if (champTel) setTimeout(function () { champTel.focus(); }, 30);
  }

  function afficherOk(prioritaire) {
    montrer(etape1, false);
    montrer(etape2, false);
    montrer(blocOk, true);
    montrer(okPrio, !!prioritaire);
    fermetureAuto = setTimeout(fermer, 2800);
  }

  /* Charge utile d'abonnement a la liste du produit. */
  function charge(attributs) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Liste attente - ' + titreProduit(),
          profile: { data: { type: 'profile', attributes: attributs } }
        },
        relationships: { list: { data: { type: 'list', id: CFG.listes[handleCourant] } } }
      }
    };
  }

  function envoi(url, corps) {
    return fetch(url + encodeURIComponent(CFG.company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(corps)
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      throw new Error('statut ' + r.status);
    });
  }

  /* Etape 1 : abonnement. Cree le profil, l'inscrit a la liste et pose le
     consentement e-mail. */
  function posterAbonnement(attributs) {
    return envoi(API_ABO, charge(attributs));
  }

  /* Etape 2 : mise a jour du profil.
     VERIFIE LE 12/09/2026 : /client/subscriptions/ ignore les attributs de
     profil quand l'abonnement a la liste existe deja (retour 202, rien
     n'est ecrit). Le numero doit donc passer par /client/profiles/, qui
     ecrit bien phone_number et les proprietes sur un profil existant. */
  function posterProfil(attributs) {
    return envoi(API_PROFIL, { data: { type: 'profile', attributes: attributs } });
  }

  function envoyerEmail(e) {
    e.preventDefault();
    cacherErreur(erreurEmail);

    var email = (champEmail && champEmail.value || '').trim();
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      afficherErreur(erreurEmail, 'Vérifie ton adresse e-mail.');
      return;
    }
    if (!CFG.listes || !CFG.listes[handleCourant] || !CFG.company) {
      afficherErreur(erreurEmail, 'Inscription indisponible pour le moment.');
      return;
    }

    boutonEmail.disabled = true;
    boutonEmail.textContent = 'ENVOI...';

    posterAbonnement({
      email: email,
      properties: {
        'Produit attendu': titreProduit(),
        'Handle attendu': handleCourant,
        'Inscription liste attente': new Date().toISOString()
      },
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    })
      .then(function () {
        emailCourant = email;
        afficherEtape2();
      })
      .catch(function () {
        boutonEmail.disabled = false;
        boutonEmail.textContent = 'PRÉVIENS-MOI';
        afficherErreur(erreurEmail, "Ça n'a pas fonctionné. Réessaie dans un instant.");
      });
  }

  function envoyerTel(e) {
    e.preventDefault();
    cacherErreur(erreurTel);

    var brut = (champTel && champTel.value || '').trim();
    var tel = normaliserTelephone(brut);
    if (!tel) {
      afficherErreur(erreurTel, 'Vérifie ton numéro de téléphone.');
      return;
    }

    var maintenant = new Date().toISOString();
    var proprietes = {
      'Produit attendu': titreProduit(),
      'Handle attendu': handleCourant,
      'Numero liste attente': tel,
      'Numero saisi brut': brut,
      'Numero saisi le': maintenant,
      'Avance 2h': true
    };
    var veutSms = !!(caseSms && caseSms.checked);
    if (veutSms) {
      proprietes['Consentement SMS'] = true;
      proprietes['Consentement SMS horodatage'] = maintenant;
      proprietes['Consentement SMS source'] = 'Liste attente - ' + titreProduit();
    }

    boutonTel.disabled = true;
    boutonTel.textContent = 'ENVOI...';

    posterProfil({ email: emailCourant, phone_number: tel, properties: proprietes })
      .then(function () {
        /* Tentative d'abonnement SMS, sans bloquer : aucun expediteur SMS
           n'existe encore sur le compte, le consentement fait foi par la
           propriete horodatee ci-dessus. */
        if (veutSms) {
          posterAbonnement({
            email: emailCourant,
            phone_number: tel,
            subscriptions: {
              email: { marketing: { consent: 'SUBSCRIBED' } },
              sms: { marketing: { consent: 'SUBSCRIBED' } }
            }
          }).catch(function () {});
        }
        afficherOk(true);
      })
      .catch(function () {
        boutonTel.disabled = false;
        boutonTel.textContent = "OUI, JE VEUX MES 2 H D'AVANCE";
        afficherErreur(erreurTel, "Ça n'a pas fonctionné. Réessaie dans un instant.");
      });
  }

  window.eraWaitlistOuvrir = ouvrir;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
